/**
 * Arranque SIP lo antes posible (módulo / Teléfono / App).
 * start() es idempotente: si ya hay UA o un start en curso, no pisa la llamada.
 */
let inFlight: Promise<void> | null = null;

export function kickSoftphoneStart(): Promise<void> {
  if (inFlight) return inFlight;
  inFlight = (async () => {
    const { startSoftphoneClient } = await import('./SoftphoneClient');
    const { sipSoftphone } = await import('./SipSoftphone');
    const { fetchSoftphoneCredentials, fetchSoftphoneMe } = await import('./softphoneApi');
    startSoftphoneClient();
    try {
      const [me, creds] = await Promise.all([
        fetchSoftphoneMe().catch(() => null),
        fetchSoftphoneCredentials(),
      ]);
      if (me) {
        sipSoftphone.applyDndSettings({
          manualEnabled: Boolean(me.softphone_dnd),
          manualScope: me.softphone_dnd_scope || 'both',
          rules: me.softphone_dnd_rules || [],
          serverTimezone: me.server_timezone,
          effective: me.dnd_effective,
        });
      }
      await sipSoftphone.start(creds);
    } catch (e) {
      sipSoftphone.noteBootstrapError(e);
    }
  })().finally(() => {
    inFlight = null;
  });
  return inFlight;
}
